export const MESSAGES = {
    REMOVE_DEVICE: 'Sure you want to remove',
    REMOVE_INSTRUCTIONS: 'Please check your internet connection and try again lorem exit the app and try again later. Alternatively you can contact our Suppor… ',
    PRIMARY_BTN_TEXT: 'Yes, Remove Device',
    SECONDARY_BTN_TEXT: 'Cancel',
}